// extracted by mini-css-extract-plugin
export var articleContainer = "style-module--articleContainer--9ec4e";
export var imageContainer = "style-module--imageContainer--31d80";
export var info = "style-module--info--c43a6";
export var list = "style-module--list--34d26";
export var masked = "style-module--masked--6f4f7";
export var saveContainer = "style-module--saveContainer--b44a3";
export var title = "style-module--title--039a8";
export var titleContainer = "style-module--titleContainer--a55ea";
export var voiceContainer = "style-module--voiceContainer--bb301";